import { Action } from "../../../actions/actions";
import { HallsActionTypes } from "../actions/actionTypes";
import Moment from "moment";

export enum LICENSE_STATES {
    UPLOAD_SEED = 0,
    AWAIT_ID_CONFIRMATION = 1,
    AWAIT_LICENSE = 2,
    LICENSE_APPLYED = 3
}

export interface ServerLicense {
    duration: number;
    expiration: string;
    expired: boolean;
    hall_id: number;
    last_updated: string;
    sequence_number: number;
    server_id: number;
}
export interface LicenseServerData {
    license: any ;
    machines: any;
    multiprogressives: any;
    progressives: any;
}
export function serverLicenseLoading(state: boolean = false, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SERVER_LICENSE:
            return true;
        case HallsActionTypes.GET_SERVER_LICENSE_SUCCESS:
        case HallsActionTypes.GET_SERVER_LICENSE_FAIL:
            return false;
        default:
            return state;
    }
}

export function serverLicense(state: ServerLicense = null, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SERVER_LICENSE_SUCCESS:
        case HallsActionTypes.UPDATE_LICENSE_DURATION_SUCCESS:
            return action.payload;
        case HallsActionTypes.GET_SERVER_LICENSE_FAIL:
            return null;
        default:
            return state;
    }
}

export function serverDurationSet(state: boolean = false, action: Action) {
    switch (action.type) {
        case HallsActionTypes.UPDATE_LICENSE_DURATION_SUCCESS:
            return true;
        case HallsActionTypes.UPDATE_LICENSE_DURATION_FAIL:
            return false;
        case HallsActionTypes.CLEAR_LICENSE_DURATION:
            return false;
        default:
            return state;
    }
}

export function serverLicenseState(state: number = 0, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_SERVER_LICENSE_STATE_SUCCESS:
        case HallsActionTypes.REJECT_LICENSE_ID_SUCCESS:
        case HallsActionTypes.CANCEL_LICENSE_PROCESS_SUCCESS:
        case HallsActionTypes.CONFIRM_LICENSE_ID_SUCCESS:
        case HallsActionTypes.UPLOAD_LICENSE_SEED_SUCCESS:
        case HallsActionTypes.UPDATE_LICENSE_STATE:
        case HallsActionTypes.SET_LICENSE_APPLIED_SUCCESS:
        case HallsActionTypes.RENEW_LICENSE_SUCCESS:
        case HallsActionTypes.UPDATE_REMOTELY_LICENSE_SUCCESS:
        case HallsActionTypes.INVALIDATE_LICENSE_SUCCESS:
            return action.payload.state;
        default:
            return state;
    }
}

export function licenseActivitiesPage(state: number = 0, action: Action) {
    switch (action.type) {
        case HallsActionTypes.RESET_ACTIVITIES:
            return 0;
        case HallsActionTypes.GET_LICENSE_ACTIVITY:
            return action.payload.page;
        default:
            return state;
    }
}

export function licenseActivities(state: any = {}, action: Action) {
    switch (action.type) {
        case HallsActionTypes.GET_LICENSE_ACTIVITY:
            return action.payload.page == 0 ? {} : state;
        case HallsActionTypes.GET_LICENSE_ACTIVITY_SUCCESS:
            let currentActivities = [];
            if (
                state.unprocessedActivities &&
                state.unprocessedActivities.length > 0 &&
                state.serverId == action.payload.serverId
            ) {
                currentActivities = [...state.unprocessedActivities];
            }

            currentActivities = currentActivities.concat(
                action.payload.activities
            );

            const results = currentActivities.reduce((acc, obj) => {
                const updateDate = Moment(obj.date).format("DD MMM YYYY");
                if (!acc[updateDate]) {
                    acc[updateDate] = [obj];
                } else {
                    acc[updateDate].unshift(obj);
                }
                return acc;
            }, {});

            return {
                activities: results,
                unprocessedActivities: state.unprocessedActivities
                    ? state.unprocessedActivities.concat(
                          action.payload.activities
                      )
                    : action.payload.activities,
                serverId: action.payload.serverId,
                finished: action.payload.activities.length < 12 ? true : false
            };
        case HallsActionTypes.GET_SERVER_LICENSE_FAIL:
        default:
            return state;
    }
}

export function licenseActivitiesLoading(
    state: boolean = false,
    action: Action
) {
    switch (action.type) {
        case HallsActionTypes.GET_LICENSE_ACTIVITY:
            return true;
        case HallsActionTypes.GET_LICENSE_ACTIVITY_SUCCESS:
        case HallsActionTypes.GET_LICENSE_ACTIVITY_FAIL:
            return false;
        default:
            return state;
    }
}
